var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9608 7.16342V6.80775C22.9608 5.17274 21.6306 3.84253 19.9956 3.84253H2.96522C1.33016 3.84258 0 5.17274 0 6.80775V7.16342H22.9608Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5651 16.7017C13.5651 15.1636 14.0598 13.7017 14.9731 12.4968H0V16.6331C0 18.2681 1.33016 19.5983 2.96522 19.5983H14.1911C13.7813 18.7007 13.5651 17.7179 13.5651 16.7017ZM11.4804 15.803H8.92125V14.2796H11.4804V15.803ZM3.41545 14.2796H7.39781V15.803H3.41545V14.2796Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5547 10.9734C17.7165 10.1606 19.0967 9.72262 20.5443 9.72262C21.3822 9.72262 22.1973 9.86974 22.9608 10.1509V8.68689H0V10.9734H16.5547Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16.7018C26 13.6887 23.5573 11.2461 20.5442 11.2461C17.5311 11.2461 15.0885 13.6887 15.0885 16.7018C15.0885 19.7149 17.5311 22.1575 20.5442 22.1575C23.5573 22.1575 26 19.7149 26 16.7018ZM21.2796 19.6164V20.2364H20.5179V20.2364V20.2364H19.7562V19.6209C19.2957 19.465 18.9189 19.1906 18.5509 18.9215L19.4503 17.6919C19.9446 18.0534 20.1976 18.2272 20.5442 18.2272C20.7402 18.2272 20.8989 18.1339 20.9585 17.9838C21.0305 17.802 20.9287 17.6345 20.6861 17.5357C20.6861 17.5357 19.5973 17.1726 19.0939 16.6593C18.6715 16.2288 18.5372 15.622 18.6716 15.0447C18.807 14.4635 19.1994 14.0091 19.7562 13.7822V13.1671H21.2796V13.7567C21.6665 13.8641 21.994 14.0229 22.1823 14.1251L21.4555 15.464C20.9736 15.2024 20.5303 15.1239 20.3577 15.1829C20.1903 15.2401 20.1648 15.3493 20.1552 15.3904C20.1417 15.4486 20.1344 15.538 20.2276 15.6418C20.3172 15.7417 21.2605 16.1248 21.2605 16.1248C22.2782 16.5391 22.7572 17.5795 22.3747 18.5449C22.176 19.0467 21.776 19.4267 21.2796 19.6164Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.320432b5f4d5864fa44efb8f0f469b8b.svg";
export { ForwardRef as ReactComponent };